import React from 'react';
import Switch from 'react-switch';
import {App} from '../../app/AppSingleton';
import {AppSignals} from '../../app/AppSignals';
import {VIEW_CONFIGS, ViewMode, ViewModeEnum} from '../../models/view-types';
import {Icons} from '../../constants/icons';
import DropdownMenu from '../elements/DropdownMenu/DropdownMenu';
import './ViewModeToggle.css';
import {MenuItemSpec} from "../elements/DropdownMenu/MenuItemSpec";
import {MenuItemAction} from "../elements/DropdownMenu/MenuItemAction";
import {MenuItemSwitch} from "../elements/DropdownMenu/MenuItemSwitch";
import {MenuItemHeader} from "../elements/DropdownMenu/MenuItemHeader";

interface ViewModeToggleProps {
	// Пропсы компонента, если они есть
}

interface ViewModeToggleState {
	currentMode: ViewMode;
	switches: {
		'auto-mode': boolean;
		'filters': boolean;
	};
}


class ViewModeToggle extends React.Component<ViewModeToggleProps, ViewModeToggleState> {
	private classBlock = 'view-mode-toggle';
	private app: App;
	private unsubscribe?: () => void;

	constructor(props: ViewModeToggleProps) {
		super(props);
		this.app = App.getInstance();

		this.state = {
			currentMode: this.app.getCurrentViewMode(),
			switches: {
				'auto-mode': !localStorage.getItem('preferredViewMode'),
				'filters': this.app.getState().showFilters || false
			}
		};
	}

	componentDidMount() {
		this.unsubscribe = AppSignals.viewModeChanged.subscribe(mode => {
			this.setState({
				currentMode: mode,
				switches: {
					...this.state.switches,
					'auto-mode': !localStorage.getItem('preferredViewMode')
				}
			});
		});
	}

	componentWillUnmount() {
		if (this.unsubscribe) {
			this.unsubscribe();
		}
	}

	private handleModeSelect = (mode: ViewMode): void => {
		App.getInstance().setViewMode(mode, 'manual');
		this.forceUpdate();
	};

	private handleSwitchChange = (id: string, checked: boolean): void => {
		if (id === 'auto-mode') {
			if (checked) {
				localStorage.removeItem('preferredViewMode');

				const width = window.innerWidth;
				let autoMode: ViewMode = ViewModeEnum.List;

				if (width < 768) {
					autoMode = ViewModeEnum.List;
				} else /*if (width < 1024) */{
					autoMode = ViewModeEnum.Columns;
				}

				this.app.setViewMode(autoMode, 'auto');
			} else {
				localStorage.setItem('preferredViewMode', this.state.currentMode);
			}
		} else if (id === 'filters') {
			this.app.setShowFilters(checked);
		}

		this.setState(prevState => ({
			switches: {
				...prevState.switches,
				[id]: checked
			}
		}));
	};

	// Вспомогательные методы
	private getCurrentConfig() {
		const {currentMode} = this.state;
		return VIEW_CONFIGS[currentMode] || VIEW_CONFIGS[ViewModeEnum.Columns];
	}

	private getStats() {
		return this.app.getListStats();
	}

	// Методы рендеринга элементов меню
	private renderDivider = (spec: MenuItemSpec): React.ReactNode => {
		const classBlock = 'dropdown';
		return <hr className={`${classBlock}__item-divider`}/>;
	};

	private renderSwitch = (spec: MenuItemSpec): React.ReactNode => {
		const {id} = spec;
		const classBlock = 'dropdown';

		if (!id) return null;

		//@ts-ignore
		const checked = this.state.switches[id as any];
		const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
		return (
			<>
				<Switch
					id={`${id}-switch`}
					checked={checked}
					onChange={(checked) => this.handleSwitchChange(id, checked)}
					onColor="#10b981"
					offColor="#9ca3af"
					onHandleColor="#ffffff"
					offHandleColor="#ffffff"
					checkedIcon={false}
					uncheckedIcon={false}
					height={20}
					width={40}
					handleDiameter={16}
					className={`${classBlock}__item-switch`}
				/>
				<label className={`${classBlock}__item-label`} htmlFor={`${id}-switch`} title={spec.tooltip}>
					{label}
				</label>
			</>
		);
	};

	private renderStats = (spec: MenuItemSpec): React.ReactNode => {
		const {id} = spec;
		const classBlock = 'dropdown';

		if (!id || !this.state.switches.filters) return null;

		const stats = this.getStats();
		const statsData = [
			{label: 'Все:', value: stats.total},
			{label: 'Не синхр.:', value: stats.unsynced}
		];

		return (
			<div className={`${classBlock}__item-stats`}>
				{statsData.map((stat, index) => (
					<div key={index} className={`${classBlock}__item-stat`}>
						<span className={`${classBlock}__item-stat-label`}>{stat.label}</span>
						<span className={`${classBlock}__item-stat-value`}>{stat.value}</span>
					</div>
				))}
			</div>
		);
	};

	// Создание спецификации меню
	private getMenuSpecification(): MenuItemSpec[] {
		return [
			// Заголовок
			{
				id: "header",
				render: MenuItemHeader,
				title: "Режим отображения",
				subtitle: "Настройте отображение задач"
			},
			// Опция "Настроить доску"
			{
				id: 'edit-board',
				render: MenuItemAction,
				icon: '⚙️',
				label: (spec)=> ((this.app.getCurrentViewMode() === ViewModeEnum.Columns) ? 'Настроить доску':'Настроить список'),
				tooltip: 'Изменить названия колонок и другие настройки доски',
				onClick: ()=>this.app.editModeStart(),
				autoClose: true,
			},

			// Разделитель
			// {
			// 	id: "divider-1",
			// 	render: this.renderDivider
			// },
			//
			// Переключатель авто-режима
			// {
			// 	id: "auto-mode",
			// 	render: this.renderSwitch,
			// 	label: "Автоматический режим",
			// 	tooltip: "Автоматически выбирает режим в зависимости от размера экрана"
			// },

			// Переключатель фильтров
			// {
			// 	id: "filters",
			// 	render: this.renderSwitch,
			// 	label: "Показать фильтры",
			// 	tooltip: "Отображать панель фильтров в интерфейсе"
			// },
			//
			// // Статистика фильтров
			// {
			// 	id: "filter-stats",
			// 	render: this.renderStats
			// },

			// Разделитель
			{
				id: "divider-2",
				render: this.renderDivider
			},

			// Опция "Доска задач"
			{
				id: "view-mode-columns",
				render: MenuItemSwitch,
				label: "Доска задач",
				tooltip: "Доска задач с колонками для CRM-воронки и Kanban, ",
				icon: Icons.Desktop,
				autoClose: true,

				mode: ViewModeEnum.Columns,
				getCurrentMode:()=>App.getInstance().getViewMode(),
				onClick:(spec)=>this.handleModeSelect(spec.mode as ViewMode)
			},

			// Опция "Список задач"
			{
				id: "view-mode-list",
				render: MenuItemSwitch,
				label: "Список задач",
				tooltip: "Компактный список всех задач",
				icon: Icons.Columns,
				autoClose: true,

				mode: ViewModeEnum.List,
				getCurrentMode:()=>App.getInstance().getViewMode(),
				onClick:(spec)=>this.handleModeSelect(spec.mode as ViewMode)
			}
		];
	}

	render() {
		const currentConfig = this.getCurrentConfig();

		return (
			<div className={this.classBlock}>
				<DropdownMenu
					buttonProps={{
						icon: currentConfig.icon,
						label: currentConfig.name,
						title: "Переключить режим отображения",
						className:this.classBlock +"--button"

					}}
					menuItems={this.getMenuSpecification()}
				/>
			</div>
		);
	}
}

export default ViewModeToggle;